export default __webpack_public_path__ + "static/media/img9.381d981c.png";